export const CONFIGURATION_APP_LOGS = "configurationAppLogs"
export const CONFIGURATION_APP_TO_SAVE = "configurationAppToSave"
export const CONFIGURATION_APP_LOGS_REFRESH = "configurationAppLogsRefresh"
